import { showError, showSuccess } from '@calendly/alert';
import { I18n } from '@calendly/i18n';
import { Button } from '@calendly/ui/components/button';
import { IconLink } from '@calendly/ui/components/glyphs/IconLink';
import { IconMailForward } from '@calendly/ui/components/glyphs/IconMailForward';
import { UiIcon } from '@calendly/ui/components/ui-icon';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { useDispatch } from 'react-redux';
import { RECAP_ACCESS_LEVELS } from 'features/recaps/constants';
import { useRecapShare } from 'features/recaps/meeting_list/meeting_card/recap_share_context';
const containerCss = "cn0lsfa";
const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(containerCss, props.className)} />;
});
const leftActionsCss = "lg72yr7";
const LeftActions = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(leftActionsCss, props.className)} />;
});
export const Footer = ({
  onSendCustomizedEmail
}) => {
  const {
    shareModal: {
      closeAfterSave: closeShareModalAfterSave
    },
    accessLevel: {
      value: accessLevel
    },
    shareLink: {
      url: shareLinkUrl,
      copy: handleCopyShareLink
    },
    submission: {
      submit: submitPermissions,
      isSubmitting
    },
    validation: {
      hasInvalidPendingRecipients,
      setShowInvalidEmailError
    }
  } = useRecapShare();
  const dispatch = useDispatch();
  const handleSaveChanges = async () => {
    if (hasInvalidPendingRecipients) {
      setShowInvalidEmailError(true);
      return;
    }
    try {
      await submitPermissions();
    } catch {
      dispatch(showError(I18n.t('publisher.meeting_recap.share_modal.errors.save_changes_failed')));
      return;
    }
    dispatch(showSuccess(I18n.t('publisher.meeting_recap.share_modal.success_toast')));
    closeShareModalAfterSave();
  };
  const isCopyLinkDisabled = isSubmitting || accessLevel === RECAP_ACCESS_LEVELS.PRIVATE || !shareLinkUrl;
  return <Container>
      <LeftActions>
        <Button decoration="secondary-outline" onClick={handleCopyShareLink} disabled={isCopyLinkDisabled}>
          <UiIcon icon={IconLink} size="small" title="" spacingRight={4} />
          {I18n.t('publisher.meeting_recap.share_modal.footer.copy_link')}
        </Button>
        <Button decoration="secondary-outline" onClick={onSendCustomizedEmail} disabled={isSubmitting}>
          <UiIcon icon={IconMailForward} size="small" title="" spacingRight={4} />
          {I18n.t('publisher.meeting_recap.share_modal.footer.send_customized_email')}
        </Button>
      </LeftActions>
      <Button onClick={handleSaveChanges} loading={isSubmitting} disabled={isSubmitting} data-testid="share-modal-save-changes">
        {I18n.t('publisher.meeting_recap.share_modal.footer.save_changes')}
      </Button>
    </Container>;
};

require("./footer.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./footer.js");